var _path, _path2, _ellipse, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M54,16.5c0,1.24-0.5,2.37-1.32,3.18C51.87,20.5,50.74,21,49.5,21h-35c-2.49,0-4.5-2.01-4.5-4.5 c0-1.18,0.45-2.26,1.21-3.06c0.03-0.04,0.07-0.08,0.11-0.12C12.13,12.5,13.26,12,14.5,12h35C51.99,12,54,14.01,54,16.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,12c0,2.76-2.24,5-5,5H16c-1.38,0-2.63-0.56-3.54-1.46c-0.57-0.58-1.01-1.3-1.25-2.1 c0.03-0.04,0.07-0.08,0.11-0.12C12.13,12.5,13.26,12,14.5,12H36z",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 20,
    ry: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M49.5,51h-35c-2.485,0-4.5-2.015-4.5-4.5v0c0-2.485,2.015-4.5,4.5-4.5h35c2.485,0,4.5,2.015,4.5,4.5 v0C54,48.985,51.985,51,49.5,51z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M49.5,36h-35c-2.485,0-4.5-2.015-4.5-4.5v0c0-2.485,2.015-4.5,4.5-4.5h35c2.485,0,4.5,2.015,4.5,4.5 v0C54,33.985,51.985,36,49.5,36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,42h-2.98c-0.08,0.89,0.08,1.79,0.45,2.59c0.31,0.66-0.18,1.41-0.9,1.41H37 c-2.76,0-4.99,2.23-5,5h17.5c1.24,0,2.37-0.5,3.18-1.32C53.5,48.87,54,47.74,54,46.5C54,44.01,51.99,42,49.5,42z",
    opacity: 0.15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5,17h-4c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h4c0.829,0,1.5,0.671,1.5,1.5 S21.329,17,20.5,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpen);
export default __webpack_public_path__ + "static/media/menu_open.70eb0936d320d8ae0239cabbc44c099c.svg";
export { ForwardRef as ReactComponent };